import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import Homescreen from './Views/Homescreen_View';
import Order from './Views/Orderscreen_View';
import ConfirmedOrder from './Views/Order_Confirmed_View';
import HighTea from './Views/High_Teas_View';
import Shop from './Views/Shop_View';
import Basket from './Views/Basket_View';
import Contact from './Views/Contact_View';
import LoginScreen from './Views/Login_View';
import AdminHomeScreen from './Views/Admin_Homescreen';

function App() {

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Homescreen />} />
          <Route path="/order" element={<Order />} />
          <Route path="/order-confirmation" element={<ConfirmedOrder />} />
          <Route path="/highteas" element={<HighTea />} />
          <Route path="/weekmenu" element={<Shop />} />
          <Route path="/winkelmandje" element={<Basket />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/dashboard" element={<AdminHomeScreen />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;